import React, { useContext } from 'react';

import { useLandingContext } from 'components/Pages/Admin/shared/ItinerariesItemLanding/Builder/functions';
import AgentContactsModalContent from 'components/shared/AgentContactsModalContent';
import LandingPage from 'components/shared/LandingPage';
import PageHeader from 'components/shared/LandingPage/blocks/PageHeader';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import LandingPageLayoutContext from 'components/shared/LandingPage/contexts/LandingPageLayoutContext';
import Modal from 'components/shared/Modal';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { isCheckSubscriptionPermissions, PERMISSION_REMOVE_BRANDING } from 'hooks/useIsSubscriptionAllowed';
import { getLangingPageType } from 'utils/itineraries/functions';

import { SHARE_TYPE } from '../../../Admin/Itineraries/Share/constants';
import ShareForm from '../../../Admin/Itineraries/Share/Form';
import { useUpgradedItineraryContext } from './functions';
import s from './index.module.css';

function ItineraryLandingPage(props) {
  const {
    pageIndex,
    screens,
    isLastPage,
    isPrivate,
    manageHideCostsPermission,
    extraHeaderOptionsLandingPageContext,
    landingTheme,
  } = props;
  const landingPageType = getLangingPageType(props.landingData);
  const contextValue = useLandingContext({
    ...props,
    landingPageType,
    isPrivate,
    manageHideCostsPermission,
    landingTheme,
  });
  const { context, showAgentContactsModal, showShareWithFriends, closeAgentContactsModal, closeShareWithFriendsModal } =
    useUpgradedItineraryContext(contextValue);
  const isRemoveBrandingAllowed = isCheckSubscriptionPermissions(
    context.page.subscriptions,
    PERMISSION_REMOVE_BRANDING,
  );
  const consultantName =
    context.page?.brandSettings?.firstName &&
    `${context.page?.brandSettings?.firstName} ${context.page?.brandSettings?.lastName}`;
  const { headerRef } = useContext(LandingPageLayoutContext);

  return (
    <LandingPageContext.Provider
      value={{
        ...context,
        headerOptions: {
          ...context.headerOptions,
          ...extraHeaderOptionsLandingPageContext,
        },
        readOnly: true,
        isPortalItinerary: true,
        hasPoweredBy: !isRemoveBrandingAllowed && isLastPage,
      }}
    >
      {pageIndex === 0 && (
        <>
          <div ref={headerRef}>
            <PageHeader links={screens} />
          </div>

          <Modal
            className="custom-agent-contacts-modal"
            isOpen={showAgentContactsModal}
            toClose={closeAgentContactsModal}
            contentClassName={s.contactsModal}
            size="md"
            noPortal
            noPadding
          >
            <AgentContactsModalContent
              phone={context.page?.brandSettings?.contactPhone}
              whatsapp={context.page?.brandSettings?.whatsapp}
              mobile={context.page?.brandSettings?.messagePhone}
              email={context.page?.brandSettings?.email}
              skype={context.page?.brandSettings?.skype}
              companyName={context.page?.brandSettings?.companyName}
              consultantName={consultantName}
            />
          </Modal>

          {showShareWithFriends && (
            <Modal className="custom-share-with-friends-modal" isOpen toClose={closeShareWithFriendsModal} size="lmd">
              <ShareForm
                shareWithType={SHARE_TYPE.FRIEND}
                showProposalLink={false}
                showPermissions={context.manageHideCostsPermission}
                manageHideCosts={context.manageHideCostsPermission}
                hideHideCosts={context.page.itineraryCostsPageHidden}
                itinerariesItemType={ITINERARIES_ITEM_TYPES.GUEST_PORTAL} // hard coded item type since at the moment only guest portal has share with frineds
                closeModal={closeShareWithFriendsModal}
                itemId={
                  contextValue.itinerariesItemType === ITINERARIES_ITEM_TYPES.ITINERARY
                    ? contextValue.page.guestPortalId
                    : contextValue.page.id
                }
                itinerariesItem={context.page}
              />
            </Modal>
          )}
        </>
      )}

      <LandingPage
        index={pageIndex}
        landingPageType={landingPageType}
        anchor={props.anchor}
        className={s.itineraryLandingPage}
      />
    </LandingPageContext.Provider>
  );
}

export default ItineraryLandingPage;
